import { all, fork } from 'redux-saga/effects';
import { notificationsSaga } from './notificationsSaga';
import { authSaga } from './authSaga';

export default function* rootSaga() {
    yield all([
        fork(authSaga),
        fork(notificationsSaga),
    ]);
}